export enum ContractLineItemStatus {
  Active,
  Waiting,
  Completed,
  Cancelled,
}

export const CONTRACT_LINE_ITEM_STATUS_CODES = {
  "codes.lineItemStatus.01": ContractLineItemStatus.Waiting,
  "codes.lineItemStatus.02": ContractLineItemStatus.Active,
  "codes.lineItemStatus.05": ContractLineItemStatus.Completed,
  "codes.lineItemStatus.06": ContractLineItemStatus.Completed,
  "codes.lineItemStatus.07": ContractLineItemStatus.Cancelled,
};
